<template>
    <div class="d-inline">
        <span class="text-success ml-1" v-if="mostrarIconeFinanceiro">
            <i
                class="fa fa-check-circle fa-lg"
                title="Processo Recebido/Quitado"
            ></i>
        </span>
        <app-status
            class="text-success ml-1"
            v-if="statusLabel"
            :status="statusLabel"
        ></app-status>
    </div>
</template>

<script>
import { StatusComprometimento } from './StatusComprometimento'

export default {
    props: {
        consultoria: Object
    },

    data() {
        return {}
    },

    computed: {
        mostrarIconeFinanceiro() {
            return (
                this.consultoria &&
                (this.consultoria.statusIdFat == 'F' ||
                    this.consultoria.statusIdFat == 'Q')
            )
        },

        statusLabel() {
            switch (this.consultoria.statusComprometimento) {
                case StatusComprometimento.NAO_COMPROMETIDO:
                    return 'NÃO COMPROMETIDO'
                case StatusComprometimento.ERRO:
                    return 'ERRO'
                case StatusComprometimento.COMPROMETIMENTO_EXCLUIDO:
                    return 'EXCLUÍDO'
                case StatusComprometimento.ATUALIZAR_COMPROMETIMENTO:
                    return 'EM ATUALIZAÇÃO'
                default:
                    return null
            }
        }
    }
}
</script>
